import { Dialog, IconButton, Typography } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import React, { useMemo } from "react";
import { FormButton } from "../../atoms";
import { ErrorTickIcon, SuccessTickIcon } from "../../icons";

export type ShowActionType = {
  title?: string;
  desc?: string;
  color?: "success" | "error" | "warning" | "info";
  showIcon?: boolean;
  icon?: React.ReactNode;
  buttonText?: string;
  onClose?: () => void;
};
export type ModalStateProps = {
  open: boolean;
} & ShowActionType;

type MessageModalProps = {
  handleState: (params: any) => void;
} & ModalStateProps;
export const MessageModal = ({ buttonText = "Close", color = "success", desc = "", icon, title = "", showIcon = true, open = false, onClose = () => {}, handleState }: MessageModalProps) => {
  //   const [state, setState] = useState({ open: false } as ModalStateProps);
  const handleClose = () => {
    onClose();
    handleState({ open: false });
  };
  const IconView = useMemo(() => {
    const props = { color: color, sx: { width: "5rem", height: "5rem" } };
    if (icon) return icon;
    switch (color) {
      case "error":
        return <ErrorTickIcon {...props} />;
      case "success":
        return <SuccessTickIcon {...props} />;
      default:
        return <ErrorIcon {...props} />;
    }
  }, [color]);
  return (
    <Dialog open={open} maxWidth={"xs"} onClose={handleClose}>
      <IconButton onClick={handleClose} sx={{ position: "absolute", right: "1.5625rem", top: "0.9375rem", zIndex: 100000 }}>
        <CloseIcon sx={{}} />
      </IconButton>
      <DialogContent sx={{ position: "relative" }}>
        <Stack spacing={2} alignItems="center" sx={{ textAlign: "center" }}>
          {showIcon && IconView}
          {title && <Typography sx={{ fontSize: "1.875rem", fontWeight: 700 }}>{title}</Typography>}
          {desc && <Typography sx={{ fontSize: "1.125rem", fontWeight: 500 }}>{desc}</Typography>}
        </Stack>
      </DialogContent>
      <DialogActions>
        <FormButton label={buttonText || "Close"} fullWidth onClick={handleClose} />
      </DialogActions>
    </Dialog>
  );
};
